var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBLBASEINFO" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.isOld && !_vm.disabled && _vm.editable
                            ? _c("c-btn", {
                                attrs: { label: "LBLREMOVE", icon: "remove" },
                                on: { btnClicked: _vm.deleteData },
                              })
                            : _vm._e(),
                          !_vm.disabled && _vm.isOld && _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.completeUrl,
                                  isSubmit: _vm.isComplete,
                                  param: _vm.measData,
                                  mappingType: "PUT",
                                  label: "LBLCOMPLETE",
                                  icon: "check",
                                },
                                on: {
                                  beforeAction: _vm.completeData,
                                  btnCallback: _vm.completeCallback,
                                },
                              })
                            : _vm._e(),
                          !_vm.disabled && _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.measData,
                                  mappingType: _vm.mappingType,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "측정기관",
                            name: "measPlaceName",
                          },
                          model: {
                            value: _vm.measData.measPlaceName,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "measPlaceName", $$v)
                            },
                            expression: "measData.measPlaceName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            type: "year",
                            disabled: _vm.disabled,
                            label: "측정년도",
                            name: "measYear",
                          },
                          model: {
                            value: _vm.measData.measYear,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "measYear", $$v)
                            },
                            expression: "measData.measYear",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            required: "",
                            type: "edit",
                            editable: _vm.editable,
                            codeGroupCd: "WORK_MEAS_QUARTER_CD",
                            itemText: "codeName",
                            disabled: _vm.disabled,
                            itemValue: "code",
                            name: "measQuarter",
                            label: "분기",
                          },
                          model: {
                            value: _vm.measData.measQuarter,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "measQuarter", $$v)
                            },
                            expression: "measData.measQuarter",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            editable: _vm.editable,
                            type: "date",
                            disabled: _vm.disabled,
                            label: "측정기간",
                            range: true,
                            name: "measPeriod",
                          },
                          model: {
                            value: _vm.measPeriod,
                            callback: function ($$v) {
                              _vm.measPeriod = $$v
                            },
                            expression: "measPeriod",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.measData.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "plantCd", $$v)
                            },
                            expression: "measData.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "측정계획명",
                            name: "measPlanContent",
                          },
                          model: {
                            value: _vm.measData.measPlanContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "measPlanContent", $$v)
                            },
                            expression: "measData.measPlanContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "℃",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "작업장기온",
                            name: "measTemperature",
                          },
                          model: {
                            value: _vm.measData.measTemperature,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "measTemperature", $$v)
                            },
                            expression: "measData.measTemperature",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "%",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "작업장습도",
                            name: "measHumidity",
                          },
                          model: {
                            value: _vm.measData.measHumidity,
                            callback: function ($$v) {
                              _vm.$set(_vm.measData, "measHumidity", $$v)
                            },
                            expression: "measData.measHumidity",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-tab", {
        staticClass: "q-mt-sm",
        attrs: {
          type: "tabcard",
          align: "left",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
          inlineLabel: true,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    measData: _vm.measData,
                    contentHeight: _vm.contentHeight,
                    disabled: _vm.disabled,
                    isOld: _vm.isOld,
                  },
                  on: {
                    "update:measData": function ($event) {
                      _vm.measData = $event
                    },
                    "update:meas-data": function ($event) {
                      _vm.measData = $event
                    },
                    "update:disabled": function ($event) {
                      _vm.disabled = $event
                    },
                    "update:isOld": function ($event) {
                      _vm.isOld = $event
                    },
                    "update:is-old": function ($event) {
                      _vm.isOld = $event
                    },
                    getDetail: _vm.getDetail,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }